import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { Reveal, Eyebrow } from "./Motion";

const FAQ = [
  { q: "O que é o Laser Day?", a: "É um dia especial da Aisla Studio dedicado à depilação a laser, com condições exclusivas — como a Virilha Completa por R$ 49,90." },
  { q: "Quais áreas posso fazer no Laser Day?", a: "Todas as áreas do corpo. A virilha completa está com valor promocional; para as demais, consulte os valores pelo WhatsApp." },
  { q: "Quantas sessões são necessárias?", a: "Varia de pessoa para pessoa, conforme o tipo de pele, de pelo e a área tratada. Na avaliação indicamos o número ideal de sessões para você." },
  { q: "Preciso me preparar antes da sessão?", a: "Ao agendar, nossa equipe envia todas as orientações de preparo pelo WhatsApp para você chegar tranquila." },
  { q: "Como faço para agendar?", a: "É só tocar em qualquer botão “Agende sua sessão” e falar com a gente pelo WhatsApp (31) 99212-0911." },
];

export const Faq = () => (
  <section id="duvidas" className="py-24 sm:py-32" aria-labelledby="faq-title" data-testid="faq-section">
    <div className="mx-auto grid max-w-[1400px] gap-12 px-5 sm:px-8 lg:grid-cols-12 lg:px-12">
      <Reveal className="lg:col-span-4">
        <Eyebrow className="text-[#9A4A38]">Dúvidas frequentes</Eyebrow>
        <h2 id="faq-title" className="section-title mt-4">Tudo o que você <span className="text-metal">precisa</span> saber</h2>
      </Reveal>
      <Reveal delay={0.1} className="lg:col-span-8">
        <Accordion type="single" collapsible className="border-t border-[#2D1C18]/15">
          {FAQ.map((f, i) => (
            <AccordionItem key={f.q} value={`item-${i}`} className="border-[#2D1C18]/15">
              <AccordionTrigger className="py-6 text-left font-display text-lg tracking-tight text-[#2D1C18] hover:no-underline sm:text-xl" data-testid={`faq-trigger-${i + 1}`}>
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="pb-6 text-base leading-relaxed text-[#6B5650]" data-testid={`faq-content-${i + 1}`}>
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
